import React, { useEffect } from 'react'
import {
	CopyrightAgentLoader,
	Modal,
	ModalSection,
	PrimaryButton,
	Row,
	SearchInput,
	Typography,
} from '@copyrightagent/basic-components'
import { Button } from '@material-ui/core'
import globalUseStyle from '../../routes/Private/TransferAgreements/style'
import useStyle from './SelectRegistrationCertificateModalStyle'
import clsx from 'clsx'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useTransferAgreementsStore } from '../../routes/Private/TransferAgreements/stores/transferAgreementStore'
import { toast } from '../../store/utils'
import { uploadTransferAgreementImages } from '../../routes/Private/TransferAgreements/api'
import { useTransferAgreementStore } from './transferAgreementStore'

export const SelectTransferAgreementModal = ({
	partnerImageId,
}: {
	partnerImageId: string
}) => {
	const {
		selectTransferAgreementModalOpened,
		setSelectTransferAgreementModalOpened,
		setTransferAgreement,
	} = useTransferAgreementStore()

	const {
		fetchTransferAgreements,
		transferAgreements,
		totalTransferAgreementsCount,
		setSearchString,
		searchString,
		setTransferAgreementModalOpen,
	} = useTransferAgreementsStore()

	const globalClasses = globalUseStyle()
	const classes = useStyle()

	const handleSearch = async () => {
		fetchTransferAgreements({
			isInitialLoad: true,
		})
	}

	useEffect(() => {
		fetchTransferAgreements({
			isInitialLoad: true,
		})
	}, [])

	const selectTransferAgreement = async ({
		transferAgreementId,
		photographerName,
	}: {
		transferAgreementId: string
		photographerName: string
	}) => {
		toast('Attaching image to transfer agreement', 'info')
		const response = await uploadTransferAgreementImages({
			partnerImageIds: [partnerImageId],
			transferAgreementId,
		})
		if (response.isSuccessful) {
			setSelectTransferAgreementModalOpened(false)
			setTransferAgreement({
				transferAgreementId,
				photographerName,
			})
			await toast(
				'Successfully attached image to transfer agreement',
				'success',
			)
		} else {
			await toast('Failed to attached image to transfer agreement', 'error')
		}
	}

	return (
		<Modal
			open={selectTransferAgreementModalOpened}
			onClose={() => setSelectTransferAgreementModalOpened(false)}
			title={`Select transfer agreement`}
			titleText={
				'Attach this image to a transfer agreement by selecting from the list below'
			}
			size="large"
		>
			<ModalSection>
				<div className={classes.modalContentContainer}>
					<div className={globalClasses.searchContainer}>
						<SearchInput
							value={searchString}
							onChange={(e) => setSearchString(e.target.value)}
							placeholder={'Search for transfer agreement by photographer name'}
						/>
						<PrimaryButton
							style={{ marginLeft: '16px' }}
							text={'Search'}
							onClick={handleSearch}
						/>
					</div>
					<div
						id="modalTransferAgreementsList"
						className={globalClasses.listContainer}
						style={{
							maxHeight: '500px',
						}}
					>
						<InfiniteScroll
							className={globalClasses.infiniteScrollWrap}
							dataLength={transferAgreements.length}
							next={fetchTransferAgreements}
							hasMore={transferAgreements.length < totalTransferAgreementsCount}
							loader={
								<div key={0} className={globalClasses.loadingContainer}>
									<CopyrightAgentLoader />
								</div>
							}
							scrollableTarget="modalTransferAgreementsList"
						>
							{transferAgreements.map((transferAgreement, index) => (
								<Row justify="flex-start" key={index}>
									<div
										className={clsx(globalClasses.card)}
										onClick={() =>
											selectTransferAgreement({
												transferAgreementId:
													transferAgreement.transfer_agreement_id,
												photographerName: transferAgreement.photographer_name,
											})
										}
										style={{ display: 'flex' }}
									>
										<div
											className={globalClasses.containerWithChip}
											style={{ flex: 1 }}
										>
											<div>
												<Typography
													variant="body2"
													fontColor="rgb(142, 147, 155)"
												>
													Photographer Name
												</Typography>
												<Typography variant="body2">
													{transferAgreement.photographer_name}
												</Typography>
											</div>
										</div>
									</div>
								</Row>
							))}
						</InfiniteScroll>
					</div>
				</div>
			</ModalSection>
			<ModalSection>
				<Row justify="flex-end">
					<Button
						className={globalClasses.invisibleButton}
						onClick={() => setSelectTransferAgreementModalOpened(false)}
					>
						<Typography>Cancel</Typography>
					</Button>
					<PrimaryButton
						type="submit"
						// loading={uploading}
						text={'Upload New Agreement'}
						loadingText={'Uploading Image IDs'}
						onClick={() => {
							setSelectTransferAgreementModalOpened(false)
							setTransferAgreementModalOpen(true)
						}}
					/>
				</Row>
			</ModalSection>
		</Modal>
	)
}
